import { render, staticRenderFns } from "./DiscoverPage.vue?vue&type=template&id=26226361&"
import script from "./DiscoverPage.vue?vue&type=script&lang=js&"
export * from "./DiscoverPage.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverPage.vue?vue&type=style&index=0&id=26226361&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports